import React, { useEffect, useMemo, useState, useCallback } from "react";
import { createPortal } from "react-dom";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";

const DIST_OPTS = [
  { value: "1", label: "AVALON TRADE & LOGISTIC" },
  { value: "2", label: "MIRTHA ALCARAZ" },
  { value: "3", label: "TRANSCARGO" },
  { value: "4", label: "LADERO PARAGUAYO" },
];
const YN_LABEL = { Y: "SI", N: "NO" };
const YN_OPTS = [
  { value: "Y", label: "SI" },
  { value: "N", label: "NO" },
];

const customStyles = {
  table: { style: { borderRadius: 12, overflow: "hidden", border: "1px solid #eee" } },
  headRow: { style: { backgroundColor: "#f8f9fa" } },
  headCells: { style: { fontWeight: 600, fontSize: 13, whiteSpace: "nowrap" } },
  rows: { style: { minHeight: "52px" } },
  cells: { style: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: 14 } },
};

function ChipYN({ v }) {
  const ok = v === "Y";
  return (
    <span className={`badge ${ok ? "bg-success" : "bg-secondary"}`} title={YN_LABEL[v] || v} style={{ minWidth: 36 }}>
      {YN_LABEL[v] || v}
    </span>
  );
}

const labelDist = (v) => DIST_OPTS.find((o) => o.value === String(v))?.label || v;

/* --------------------- MODALES EN PORTAL (estado interno) --------------------- */
const CreateModal = React.memo(function CreateModal({ open, onClose, onSave }) {
  const [form, setForm] = useState({
    Code: "", U_NOMBRE: "", U_CIUDAD: "", U_NUMEROCI: "",
    U_distintivo: "", U_ructransp: "", U_Activo: "Y", U_IPS: "N",
    U_Usuario: "", password: "",
  });

  useEffect(() => {
    if (!open) return;
    // reset al abrir
    setForm({
      Code: "", U_NOMBRE: "", U_CIUDAD: "", U_NUMEROCI: "",
      U_distintivo: "", U_ructransp: "", U_Activo: "Y", U_IPS: "N",
      U_Usuario: "", password: "",
    });
  }, [open]);

  if (!open) return null;
  return createPortal(
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,.4)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content" onKeyDown={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h5 className="modal-title">Crear Chofer</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Code</label>
                <input className="form-control" value={form.Code} onChange={(e) => setForm(f => ({ ...f, Code: e.target.value }))} />
              </div>
              <div className="col-md-8">
                <label className="form-label">Nombre</label>
                <input className="form-control" value={form.U_NOMBRE} onChange={(e) => setForm(f => ({ ...f, U_NOMBRE: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Ciudad</label>
                <input className="form-control" value={form.U_CIUDAD} onChange={(e) => setForm(f => ({ ...f, U_CIUDAD: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Núm. CI</label>
                <input className="form-control" value={form.U_NUMEROCI} onChange={(e) => setForm(f => ({ ...f, U_NUMEROCI: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Distintivo</label>
                <select className="form-select" value={form.U_distintivo} onChange={(e) => setForm(f => ({ ...f, U_distintivo: e.target.value }))}>
                  <option value="">-- Seleccionar --</option>
                  {DIST_OPTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">RUC Transp.</label>
                <input className="form-control" value={form.U_ructransp} onChange={(e) => setForm(f => ({ ...f, U_ructransp: e.target.value }))} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Activo</label>
                <select className="form-select" value={form.U_Activo} onChange={(e) => setForm(f => ({ ...f, U_Activo: e.target.value }))}>
                  {YN_OPTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">IPS</label>
                <select className="form-select" value={form.U_IPS} onChange={(e) => setForm(f => ({ ...f, U_IPS: e.target.value }))}>
                  {YN_OPTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Usuario</label>
                <input className="form-control" value={form.U_Usuario} onChange={(e) => setForm(f => ({ ...f, U_Usuario: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Password</label>
                <input type="password" name="dummy-password" autoComplete="current-password" className="form-control" value={form.password} onChange={(e) => setForm(f => ({ ...f, password: e.target.value }))} />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={() => onSave(form)}>Guardar</button>
            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
});

const EditModal = React.memo(function EditModal({ open, row, onClose, onSave }) {
  const [form, setForm] = useState({
    U_NOMBRE:"", U_CIUDAD:"", U_NUMEROCI:"", U_distintivo:"",
    U_ructransp:"", U_Activo:"Y", U_IPS:"N", U_Usuario:""
  });

  useEffect(() => {
    if (!open || !row) return;
    setForm({
      U_NOMBRE: row.U_NOMBRE || "",
      U_CIUDAD: row.U_CIUDAD || "",
      U_NUMEROCI: row.U_NUMEROCI || "",
      U_distintivo: row.U_distintivo || "",
      U_ructransp: row.U_ructransp || "",
      U_Activo: row.U_Activo || "Y",
      U_IPS: row.U_IPS || "N",
      U_Usuario: row.U_Usuario || "",
    });
  }, [open, row]);

  if (!open) return null;
  return createPortal(
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,.4)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content" onKeyDown={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h5 className="modal-title">Editar Chofer: {row?.Code}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="row g-2">
              <div className="col-md-12">
                <label className="form-label">Nombre</label>
                <input className="form-control" value={form.U_NOMBRE} onChange={(e) => setForm(f => ({ ...f, U_NOMBRE: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Ciudad</label>
                <input className="form-control" value={form.U_CIUDAD} onChange={(e) => setForm(f => ({ ...f, U_CIUDAD: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Núm. CI</label>
                <input className="form-control" value={form.U_NUMEROCI} onChange={(e) => setForm(f => ({ ...f, U_NUMEROCI: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Distintivo</label>
                <select className="form-select" value={form.U_distintivo} onChange={(e) => setForm(f => ({ ...f, U_distintivo: e.target.value }))}>
                  <option value="">-- Seleccionar --</option>
                  {DIST_OPTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">RUC Transp.</label>
                <input className="form-control" value={form.U_ructransp} onChange={(e) => setForm(f => ({ ...f, U_ructransp: e.target.value }))} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Activo</label>
                <select className="form-select" value={form.U_Activo} onChange={(e) => setForm(f => ({ ...f, U_Activo: e.target.value }))}>
                  {YN_OPTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">IPS</label>
                <select className="form-select" value={form.U_IPS} onChange={(e) => setForm(f => ({ ...f, U_IPS: e.target.value }))}>
                  {YN_OPTS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Usuario</label>
                <input className="form-control" value={form.U_Usuario} onChange={(e) => setForm(f => ({ ...f, U_Usuario: e.target.value }))} />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={() => onSave(form)}>Guardar Cambios</button>
            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
});

/* --------------------------------- PÁGINA ---------------------------------- */
function Choferes() {
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [q, setQ] = useState("");

  const [showCreate, setShowCreate] = useState(false);
  const [rowEditing, setRowEditing] = useState(null);  // ← en vez de editForm/editCode
  const [showSetPwd, setShowSetPwd] = useState(false);
  const [pwdCode, setPwdCode] = useState(null);
  const [newPwd, setNewPwd] = useState("");

  const clearAlerts = useCallback(() => { setMsg(""); setErr(""); }, []);

  // API
  const fetchChoferes = useCallback(async () => {
    clearAlerts();
    try {
      const r = await apiClient.get("/choferes");
      if (Array.isArray(r.data)) setRows(r.data);
      else { setRows([]); setErr(r.data?.error || "Respuesta inválida del servidor."); }
    } catch (e) { setRows([]); setErr("Error al cargar choferes."); }
  }, [clearAlerts]);

  useEffect(() => { fetchChoferes(); }, [fetchChoferes]);

  const createChofer = useCallback(async (form) => {
    clearAlerts();
    const { Code, U_NOMBRE, U_Usuario, password } = form;
    if (!Code || !U_NOMBRE || !U_Usuario || !password) { setErr("Complete Code, U_NOMBRE, U_Usuario y password."); return; }
    try {
      const r = await apiClient.post("/choferes", form);
      if (r.data?.error) return setErr(r.data.error);
      setMsg(`Chofer ${r.data?.Code || Code} creado correctamente.`);
      setShowCreate(false);
      fetchChoferes();
    } catch { setErr("Error al crear chofer."); }
  }, [clearAlerts, fetchChoferes]);

  const updateChofer = useCallback(async (form) => {
    if (!rowEditing) return;
    clearAlerts();
    try {
      const r = await apiClient.patch(`/choferes/${rowEditing.Code}`, form);
      if (!r.data?.ok) return setErr(r.data?.error || "Error al actualizar chofer.");
      setMsg(`Chofer ${rowEditing.Code} actualizado.`);
      setRowEditing(null);
      fetchChoferes();
    } catch { setErr("Error al actualizar chofer."); }
  }, [rowEditing, clearAlerts, fetchChoferes]);

  const resetPassword = useCallback(async (code) => {
    clearAlerts();
    try {
      const r = await apiClient.post(`/choferes/${code}/reset-password`, {});
      if (r.data?.error) return setErr(r.data.error);
      const temp = r.data?.tempPassword;
      setMsg(`Password temporal (${code}): ${temp}`);
      try { if (temp && navigator?.clipboard) await navigator.clipboard.writeText(temp); } catch {}
    } catch { setErr("Error al resetear contraseña."); }
  }, [clearAlerts]);

  const setPassword = useCallback(async () => {
    clearAlerts();
    if (!newPwd || newPwd.length < 8) return setErr("La contraseña debe tener al menos 8 caracteres.");
    try {
      const r = await apiClient.post(`/choferes/${pwdCode}/set-password`, { password: newPwd });
      if (!r.data?.ok) return setErr(r.data?.error || "Error al actualizar contraseña.");
      setMsg(`Contraseña actualizada para ${pwdCode}.`);
      setShowSetPwd(false);
    } catch { setErr("Error al actualizar contraseña."); }
  }, [pwdCode, newPwd, clearAlerts]);

  // UI helpers
  const openCreate = useCallback(() => { clearAlerts(); setShowCreate(true); }, [clearAlerts]);
  const openEdit = useCallback((row) => { clearAlerts(); setRowEditing(row); }, [clearAlerts]);
  const openSetPwd = useCallback((row) => { clearAlerts(); setPwdCode(row.Code); setNewPwd(""); setShowSetPwd(true); }, [clearAlerts]);

  // filtro
  const filtered = useMemo(() => {
    if (!q) return rows;
    const s = q.toLowerCase();
    return rows.filter((r) =>
      String(r.Code).toLowerCase().includes(s) ||
      (r.U_NOMBRE || "").toLowerCase().includes(s) ||
      (r.U_Usuario || "").toLowerCase().includes(s) ||
      (r.U_CIUDAD || "").toLowerCase().includes(s)
    );
  }, [q, rows]);

  // columnas (estables)
  const columns = useMemo(() => [
    { id: 1, name: "Code", selector: r => r.Code, sortable: true, width: "85px",
      sortFunction: (a,b) => Number(a.Code) - Number(b.Code) },
    { id: 2, name: "Nombre", selector: r => r.U_NOMBRE, sortable: true, grow: 2 },
    { id: 4, name: "Núm. CI", selector: r => r.U_NUMEROCI, sortable: true, width: "140px" },
    { id: 5, name: "Distintivo", selector: r => labelDist(r.U_distintivo), sortable: true, width:"220px" },
    { id: 7, name: "Activo", selector: r => r.U_Activo, sortable: true, width:"85px", cell: r => <ChipYN v={r.U_Activo} /> },
    { id: 8, name: "IPS", selector: r => r.U_IPS, sortable: true, width:"85px", cell: r => <ChipYN v={r.U_IPS} /> },
    {
      id: 9, name: "Acciones", width: "260px",
      cell: (row) => (
        <div className="d-flex gap-2 choferes-actions">
          <button className="btn btn-sm btn-outline-primary" onClick={() => openEdit(row)}>✏️ Editar</button>
          <button className="btn btn-sm btn-outline-warning" onClick={() => resetPassword(row.Code)}>♻️ Reset</button>
          <button className="btn btn-sm btn-outline-success" onClick={() => openSetPwd(row)}>🔐 Set</button>
        </div>
      ),
    },
  ], [openEdit, resetPassword, openSetPwd]);

  return (
    <div className="container mt-4">
      <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-3">
        <h2 className="m-0">Choferes</h2>
        <div className="d-flex gap-2">
          <input
            type="search"
            className="form-control"
            style={{ minWidth: 260 }}
            placeholder="Buscar por nombre, usuario, ciudad..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            name="drivers_search"                    // nombre no parecido a “username”
            autoComplete="section-choferes off"      // separa la “sección” del login
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck={false}
            inputMode="search"
            data-lpignore="true"                     // ignora LastPass
            data-1p-ignore="true"                    // ignora 1Password
          />
          <button className="btn btn-primary" onClick={openCreate}>+ Nuevo Chofer</button>
        </div>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}
      {err && <div className="alert alert-danger">{err}</div>}

      <DataTable
        data={filtered}
        columns={columns}
        customStyles={customStyles}
        dense striped highlightOnHover responsive
        fixedHeader fixedHeaderScrollHeight="60vh"
        pagination paginationPerPage={50}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        defaultSortFieldId={2}
      />

      {/* Modales */}
      <CreateModal open={showCreate} onClose={() => setShowCreate(false)} onSave={createChofer} />
      <EditModal open={!!rowEditing} row={rowEditing} onClose={() => setRowEditing(null)} onSave={updateChofer} />

      {/* Set Password */}
      {showSetPwd && createPortal(
        <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,.4)" }}>
          <div className="modal-dialog">
            <div className="modal-content" onKeyDown={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h5 className="modal-title">Definir contraseña para {pwdCode || ""}</h5>
                <button className="btn-close" onClick={() => setShowSetPwd(false)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Nueva contraseña (mín. 8)</label>
                <input type="password" name="dummy-password" autoComplete="current-password" className="form-control" value={newPwd} onChange={(e) => setNewPwd(e.target.value)} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-success" onClick={setPassword}>Actualizar Contraseña</button>
                <button className="btn btn-secondary" onClick={() => setShowSetPwd(false)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

export default Choferes;
